<template>
  <ButtonComponent class="textCenter w100 mb-10" mod="gradient-bg" @click="goToLibrary"
    >Библиотека документов</ButtonComponent
  >
  <ButtonComponent class="textCenter w100 mb-10" mod="gradient-bg" @click="goToMedia">Мониторинг СМИ</ButtonComponent>
</template>

<script>
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';

  export default {
    name: 'Widget13',
    components: {
      ButtonComponent,
    },
    methods: {
      goToLibrary() {
        this.$router.push({ name: 'Library' });
      },
      goToMedia() {
        this.$router.push({ name: 'MassMediaCard', params: { id: 0, action: 'edit' } });
      },
    },
    data() {
      return {};
    },
    created() {},
  };
</script>

<style lang="scss" scoped></style>
